 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import TEXTHALFTITLE from '@/components/Text/HalfTitle'
 import TEXTFULLTITLE from '@/components/Text/FullTitle'
 import TEXTCOPYRIGHT from '@/components/Text/Copyright'
 import TEXTCONTENTS from '@/components/Text/Contents'
 import TEXTVERSE from '@/components/Text/Verse'
 import TEXTFOREWORD from '@/components/Text/Foreword'
 import TEXTINTRODUCTION from '@/components/Text/Introduction'
 import TEXTCGHP01 from '@/components/Text/CGHp01'
 import TEXTCGHP02 from '@/components/Text/CGHp02'
 import TEXTCGHP03 from '@/components/Text/CGHp03'
 import TEXTCGHP04 from '@/components/Text/CGHp04'
 import TEXTCGHP05 from '@/components/Text/CGHp05'
 import TEXTCGHP06 from '@/components/Text/CGHp06'
 import TEXTCGHP07 from '@/components/Text/CGHp07'
 import TEXTCGHP08_A from '@/components/Text/CGHp08_a'
 import TEXTCGHP08_BPHOTO from '@/components/Text/CGHp08_bphoto'
 import TEXTCGHP09 from '@/components/Text/CGHp09'
 import TEXTCGHP10 from '@/components/Text/CGHp10'
 import TEXTCGHP11 from '@/components/Text/CGHp11'
 import TEXTCGHP12 from '@/components/Text/CGHp12'
 import TEXTCGHP13 from '@/components/Text/CGHp13'
 import TEXTCGHP14 from '@/components/Text/CGHp14'
 import TEXTCGHP15 from '@/components/Text/CGHp15'
 import TEXTCGHP16 from '@/components/Text/CGHp16'
 import TEXTCGHP17_INDEX from '@/components/Text/CGHp17_index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/cover",
 			"name" : "Text/cover",
 			"component" : TEXTCOVER
 		},
 		{
 			"path" : "/Text/HalfTitle",
 			"name" : "Text/HalfTitle",
 			"component" : TEXTHALFTITLE
 		},
 		{
 			"path" : "/Text/FullTitle",
 			"name" : "Text/FullTitle",
 			"component" : TEXTFULLTITLE
 		},
 		{
 			"path" : "/Text/Copyright",
 			"name" : "Text/Copyright",
 			"component" : TEXTCOPYRIGHT
 		},
 		{
 			"path" : "/Text/Contents",
 			"name" : "Text/Contents",
 			"component" : TEXTCONTENTS
 		},
 		{
 			"path" : "/Text/Verse",
 			"name" : "Text/Verse",
 			"component" : TEXTVERSE
 		},
 		{
 			"path" : "/Text/Foreword",
 			"name" : "Text/Foreword",
 			"component" : TEXTFOREWORD
 		},
 		{
 			"path" : "/Text/Introduction",
 			"name" : "Text/Introduction",
 			"component" : TEXTINTRODUCTION
 		},
 		{
 			"path" : "/Text/CGHp01",
 			"name" : "Text/CGHp01",
 			"component" : TEXTCGHP01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js